import { SectionHeading } from "@/components/SectionHeading";
import { RevealGroup, RevealItem } from "@/components/Reveal";
import Marquee from "@/components/Marquee";
import { platforms } from "@/data/content";

export default function BookingPlatforms() {
  return (
    <section className="bg-mist py-24 lg:py-32" data-testid="booking-platforms">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHeading
          eyebrow="Booking Platforms"
          title="Get Your Property Where Guests Are Searching"
          subtitle="We help properties establish and optimize their presence across leading hospitality and travel platforms."
        />
      </div>

      <div className="mt-14">
        <Marquee />
      </div>

      <div className="mx-auto mt-14 max-w-7xl px-5 sm:px-8">
        <RevealGroup className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {platforms.map((p) => (
            <RevealItem key={p.name}>
              <div
                data-testid={`platform-card-${p.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className="flex h-full flex-col rounded-2xl border border-line bg-white p-7 transition-shadow duration-300 hover:shadow-float"
              >
                <div className="flex items-center gap-3">
                  <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-navy font-serif text-lg font-bold text-sky">
                    {p.name.charAt(0)}
                  </span>
                  <h3 className="font-serif text-lg font-semibold text-navy">{p.name}</h3>
                </div>
                <p className="mt-4 text-sm leading-relaxed text-slate-600">{p.desc}</p>
              </div>
            </RevealItem>
          ))}
        </RevealGroup>
        <p className="mt-8 text-center text-xs text-slate-500">
          Platform names and logos are the property of their respective owners. HM Services is an independent consultancy and does not claim official partnership with these platforms.
        </p>
      </div>
    </section>
  );
}
